<template>
  <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clipfamily)">
      <path
          d="M6.50085 5.32977C8.49203 4.08305 9.2185 3.07846 9.2185 2.22367C9.2185 1.36718 8.52417 0.672852 7.66768 0.672852C7.20229 0.672852 6.7851 0.878121 6.50085 1.20275C6.21658 0.878146 5.79939 0.672852 5.33402 0.672852C4.47753 0.672852 3.7832 1.36718 3.7832 2.22367C3.7832 3.07846 4.50967 4.08305 6.50085 5.32977Z"
          fill="currentColor"/>
      <path
          d="M6.50123 9.57474C7.05096 9.57474 7.4966 9.1291 7.4966 8.57936C7.4966 8.02963 7.05096 7.58398 6.50123 7.58398C5.9515 7.58398 5.50586 8.02963 5.50586 8.57936C5.50586 9.1291 5.9515 9.57474 6.50123 9.57474Z"
          fill="currentColor"/>
      <path
          d="M8.67188 6.12532C8.67188 6.83859 9.25214 7.41886 9.96541 7.41886C10.6787 7.41886 11.2589 6.83859 11.2589 6.12532C11.2589 5.41206 10.6787 4.83179 9.96541 4.83179C9.25214 4.83179 8.67188 5.41208 8.67188 6.12532Z"
          fill="currentColor"/>
      <path
          d="M3.05915 7.41886C3.77355 7.41886 4.35268 6.83972 4.35268 6.12532C4.35268 5.41092 3.77355 4.83179 3.05915 4.83179C2.34476 4.83179 1.76562 5.41092 1.76562 6.12532C1.76562 6.83972 2.34476 7.41886 3.05915 7.41886Z"
          fill="currentColor"/>
      <path
          d="M11.1246 7.82219C10.7947 8.04797 10.3961 8.18033 9.96702 8.18033C9.5297 8.18033 9.12416 8.04259 8.79062 7.80884C8.58098 7.89426 8.38285 8.00218 8.19931 8.12976C8.23736 8.27335 8.25787 8.42399 8.25787 8.57937C8.25787 9.09404 8.03542 9.55774 7.68164 9.87935C8.43484 10.2965 8.94595 11.0995 8.94595 12.0198V12.327H13.0009V10.6436C13.0009 9.37588 12.2258 8.28579 11.1246 7.82219Z"
          fill="currentColor"/>
      <path
          d="M4.74305 8.57939C4.74305 8.424 4.76356 8.27336 4.80162 8.12978C4.62287 8.00552 4.43032 7.89979 4.22673 7.81543C3.89496 8.04525 3.49285 8.18035 3.05959 8.18035C2.62641 8.18035 2.22433 8.04527 1.89258 7.81553C0.782795 8.27516 0 9.36962 0 10.6436V12.3271H4.05497V12.0198C4.05497 11.0995 4.56609 10.2965 5.31928 9.87939C4.96551 9.55775 4.74305 9.09406 4.74305 8.57939Z"
          fill="currentColor"/>
      <path
          d="M6.49983 10.3364C5.57158 10.3364 4.81641 11.0916 4.81641 12.0199V12.3271H8.18328V12.0199C8.18326 11.0916 7.42808 10.3364 6.49983 10.3364Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clipfamily">
        <rect width="13" height="13" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "IconFamily"
}
</script>

<style scoped>

</style>